import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    IconButton,
    Button,
    Typography,
    Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function ShowDescriptionDialog({ open, onClose, content, title = "" }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: 'hidden',
                    boxShadow: 24,
                }
            }}
        >
            <DialogTitle
                sx={{ 
                    m: 0, 
                    p: 0,
                    background: 'linear-gradient(135deg, #0ea5e9 0%, #d946ef 100%)',
                    color: 'white',
                }}
            >
                <Box sx={{ p: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.125rem', mb: 0.5, color: 'white' }}>
                            {title || "Job Description"}
                        </Typography>
                        {/* {title && (
                            <Typography variant="body2" sx={{ fontWeight:400, opacity: 0.9, fontSize: '0.875rem', color: 'white' }}>
                                Job Description
                            </Typography>
                        )} */}
                    </Box>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{ 
                            color: 'white',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>

            <DialogContent
                dividers
                sx={{
                    maxHeight: '70vh',
                    overflowY: 'auto',
                    p: 4,
                    '&::-webkit-scrollbar': {
                        width: '8px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                        borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#0ea5e9',
                        borderRadius: '4px',
                        '&:hover': {
                            background: '#0284c7',
                        },
                    },
                }}
            >
                <DialogContentText 
                    whiteSpace="pre-line"
                    sx={{
                        fontSize: '0.875rem',
                        lineHeight: 1.8,
                        color: '#374151',
                        '& p': {
                            marginBottom: '1rem',
                        },
                        '& ul, & ol': {
                            marginLeft: '1.5rem',
                            marginBottom: '1rem',
                        },
                        '& h1, & h2, & h3': {
                            marginTop: '1.5rem',
                            marginBottom: '0.75rem',
                            fontWeight: 700,
                        },
                    }}
                >
                    {content}
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={{ justifyContent: 'center', p: 3, borderTop: '1px solid #e5e7eb' }}>
                <Button 
                    onClick={onClose} 
                    variant="contained"
                    sx={{
                        px: 4,
                        py: 1.5,
                        borderRadius: 2,
                        background: 'linear-gradient(135deg, #0ea5e9 0%, #d946ef 100%)',
                        fontWeight: 600,
                        textTransform: 'none',
                        boxShadow: 3,
                        '&:hover': {
                            background: 'linear-gradient(135deg, #0284c7 0%, #c026d3 100%)',
                            boxShadow: 6,
                        },
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ShowDescriptionDialog;
